import endpoints, { baseApiUrl } from 'libs/src/config/endpoints';
import { HTTPMethod, HTTPStatusCode } from 'libs/src/enums';
import { fetchAsync } from '../../NetworkHelper';

export const fetchCustomerList = async (params: any): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.customer,
      params,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};
export const fetchChannelPartnerList = async (params: any): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.channelPartners,
      params,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchManagersList = async (params: any): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.managers,
      params,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchUnregisteredUsersList = async (params: any): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.fetchUnregisteredUsers,
      params,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchCustomerDetails = async (accountId: any): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.customer + `/${accountId}`,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchManagerDetails = async (accountId: any): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.managers + accountId,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchCustomerBankDetails = async (
  accountId: any,
): Promise<any> => {
  try {
    const request = {
      url:
        baseApiUrl +
        endpoints.customerBankDetails.replace('#{accountId}', accountId),
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchChannelPartnerDetails = async (
  accountId: any,
): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.channelPartners + `/${accountId}`,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const saveBasicDetails = async (
  holderId: any,
  accountId: any,
): Promise<any> => {
  try {
    const request = {
      url:
        baseApiUrl +
        endpoints.customer +
        `/${accountId}` +
        `/holders` +
        `/${holderId}` +
        `/basicDetails`,
      method: 'PUT',
      data: {
        firstName: 'Nirmit',
        lastName: 'Sawhney',
        fatherName: 'Rajiv Sawhney',
        emailAddress: 'nirmit.sawhney@cawstudios.com',
        mobileCountryCode: '+91',
        mobileNumber: '9999999993',
        userHolderType: 'Individual',
        residentialStatus: 'RI',
        dateOfBirth: '1969-12-31T23:59:58.004Z',
        isPrimaryHolder: true,
        gender: 'Male',
        investorProfession: 'Engineer',
      },
    };
    const response = await fetchAsync(request);
  } catch (error) {
    return [];
  }
};
export const startKYCEdit = async (
  accountId: any,
  holderId: any,
): Promise<any> => {
  try {
    const request = {
      url:
        baseApiUrl +
        endpoints.customer +
        `/${accountId}` +
        endpoints.holders +
        `/${holderId}` +
        `/kyc/verification/start`,

      method: 'PUT',
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const startChannelPartnerKYCEdit = async (
  accountId: any,
): Promise<any> => {
  try {
    const request = {
      url:
        baseApiUrl +
        endpoints.channelPartners +
        `/${accountId}` +
        `/kyc/verification/start`,

      method: 'PUT',
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchActivityLogs = async (
  accountId: any,
  params: any,
): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.eventLogs + `/${accountId}`,
      params,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const fetchPropertyLogs = async (
  propertyId: any,
  params: any,
): Promise<any> => {
  try {
    const request = {
      url: baseApiUrl + endpoints.eventLogs + `/${propertyId}`,
      params,
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};
